import React, {useEffect, useState} from 'react'
import {ReactComponent as IconBadge} from '../../../images/begtest/bb-test-badge.svg'
import BegTestRow from './BegTest/BegTestRow'
import BegTestTyresRow from './BegTest/BegTestTyresRow'
import {typesOfData} from './BegTest/classes/StatusItem'
import FieldOtherRemarks from './BegTest/FieldOtherRemarks';
import GetBegTestData from "./BegTest/GetBegTestData";
import RowImages from "./BegTest/RowImages";
import breakPoints from "../../../helpers/breakPoints";
import {StatusItemChecks} from "./BegTest/classes/StatusItemChecks";
import {StatusItemConditions} from "./BegTest/classes/StatusItemConditions";
import {StatusItemTyresets} from "./BegTest/classes/StatusItemTyresets";

const ShowMoreLink = ({showMore, onClick, isSmallScreen}) => {
    const text = showMore ? "Visa mindre" : "Visa mer av testet"
    const chevronCLass = showMore ? "chevron-up" : "chevron-down"
    return isSmallScreen ? <a className={`expandable-toggle`} onClick={onClick}>{text}</a> : <></>;
};

const TyreSets = ({showMore, isSmallScreen, data}) => {
    return !isSmallScreen || isSmallScreen && showMore ? <BegTestTyresRow data={data}/> : <></>;
}

const Images = ({showMore, isSmallScreen, images}) => {
    return !isSmallScreen || showMore ? <RowImages images={images}/> : <></>;
}

const BegTest = () => {
    const [showMore, setShowMore] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false)
    const {breakpoints} = breakPoints;
    const begTestData = GetBegTestData();

    useEffect(() => {
        if (typeof window === 'undefined') return

        const handleResize = () => setIsSmallScreen(window.innerWidth < breakpoints.md);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    })

    if (begTestData) {
        function processBegTestData() {
            const {tyresets, condition, checks} = begTestData;
            return [
                ...checks.map(subData => new StatusItemChecks(subData)),
                ...condition.map(subData => new StatusItemConditions(subData)),
                ...tyresets.map(subData => new StatusItemTyresets(subData))
            ];
        }

        const begTests = processBegTestData();

        const sectionBrand = <li className="begtest-badge"><IconBadge/></li>;

        const sectionChecksCondition = <>{begTests
            .filter(({itemType}) => itemType === typesOfData.checks || itemType === typesOfData.condition)
            .map(testData => (<BegTestRow data={testData} key={testData.key}/>))}</>;

        const sectionOtherRemarks = begTestData["other_remark"] &&
            <FieldOtherRemarks data={begTestData["other_remark"]}/>;

        const linkVD = begTestData['url_product_declaration'] &&
            <a className="begtest-vdn" href={begTestData['url_product_declaration']} target="_blank">Varudeklaration</a>;

        return <>
            <h2 className="section-title">Begtest</h2>
            <p className="section-description">
                En av våra målsättningar är att våra kunder ska känna sig trygga med sin
                bilaffär redan innan köpet. Just därför testar vi alla våra begagnade bilar. Här nedan kan du ta del av
                testresultatet.
            </p>
            {linkVD}
            <div className="section begtest">
                <ul className="begtest-details">
                    {sectionBrand}
                    {sectionChecksCondition}
                    {sectionOtherRemarks}
                    <Images images={begTestData['images']} showMore={showMore} isSmallScreen={isSmallScreen}/>
                    <TyreSets data={begTests} showMore={showMore} isSmallScreen={isSmallScreen}/>
                </ul>
                <ShowMoreLink showMore={showMore} isSmallScreen={isSmallScreen} onClick={() => setShowMore(!showMore)}/>
            </div>
        </>
    }
    return <></>
}
export default BegTest;